<!-- This templates insert a chunck if the var is defined -->
<template>
<v-container v-if="this.condition()">
  <span  >{{this.prefix}} + {{this.displayText}} {{this.suffix}}
  </span>
  <br v-if="this.br"/>
  </v-container>
</template>

<script>
export default {
  name: "SimpleItem",
  props: {
    var: { required: true },
    data: { required: true },
    field: { required: false },
    showifempty: { default: false },
    icon: {},
    br : {},
    prefix: {
      default: "",
    },
    suffix: {
      default: "",
    },
  },
  methods: {
    condition() {
      if (!this.var) {
        return false;
      }
      if (!this.data) {
        return false;
      }
      if (!(this.data in this.var) || this.var[this.data]["valeur"] == null ) {
        return false;
      }

      return this.showifempty || this.var[this.data];
    },
    displayText() {
      if (this.field && this.field == "mix") {
        return (
          this.var[this.data]["libelle"] +
          "(" +
          this.var[this.data]["valeur"] +
          ")"
        );
      }
      if (!this.field || !(this.field in this.var[this.data])) {
        return this.var[this.data];
      }
      return this.var[this.data][this.field];
    },
    displayIcon() {
      if (!this.icon) return "";
      return "fa fa-" + this.icon;
    },
  },
};
</script>
